<template>
  <div>
    <section class="block-masthead border-bottom">
      <navigation favourite-theme="light"/>

        <div class="row no-gutters">
          <div class="block col-md-6 d-flex align-items-center bg-dark">
            <div class="content">
              <img v-if="pageContent && pageContent.thumbnail" v-bind:src="pageContent.thumbnail.url" v-bind:alt="pageContent.title" class="thumbnail" />
            </div>
          </div>
          <template v-if="option">
            <div class="block col-md-6 d-flex align-items-center">
              <div class="content" data-aos="fade-up">
                <h1>{{ option.name }}</h1>
                <router-link :to="{ name: 'products', query: { producer: option.value }}" class="cta" title="Link: Products">
                  View {{ option.name }} products
                </router-link>
              </div>
            </div>
          </template>
        </div>

    </section>
    <page-content ref="content" :bordered="true"/>
    <product-slider ref="productSlider" />
    <order-steps/>
    <site-footer/>
  </div>
</template>

<script>
  import SiteFooter from '@/components/SiteFooter'
  import OrderSteps from '@/components/OrderSteps'
  import ProductSlider from '@/components/ProductSlider'
  import PageContent from '@/components/PageContent'
  import Navigation from '@/components/Navigation'

  export default {
    name: 'ProducerPage',
    components: {
      PageContent,
      ProductSlider,
      OrderSteps,
      SiteFooter,
      Navigation
    },
    data() {
      return {
        pageNumber: 1,
        paginationInterval: 100,
        filters: [],
        option: null,
        pageContent: null,
      };
    },
    methods: {
      reset: function () {
        this.filters = [];
        this.option = null;
      },
      load: function () {
        const slug = this.$route.params.slug;
        const pagination = {
          page: this.pageNumber,
          pagination_interval: this.paginationInterval
        };
        const filters = [
          {
            property: 'slug',
            value: 'producer',
            operator: '='
          }
        ];

        this.$root.$api.getCategories(pagination, filters)
          .then(response => {
            if (response.data != null) {
              const category = response.data.categories[0];

              category.category_options.forEach(option => {
                if (option.value === slug) {
                  this.option = option;
                  this.loadRelatedProducts();

                }
              });
            }
          }).catch(error => {
          console.log(error);
        })
      },
      loadPageContent: function () {
        const slug = this.$route.params.slug;
        this.$root.$api.getPageBySlug(slug)
          .then(response => {
            if (response.data != null) {
              this.pageContent = response.data.pages[0];
              this.$refs.content.loadContent(this.pageContent.content[0]);
            }
          }).catch(error => {
          console.log(error);
        })
      },
      loadRelatedProducts: function () {
        const filters = [
          {
            property: 'category_options',
            value: [this.option.id],
            operator: '='
          }
        ];

        this.$refs.productSlider.introText = this.option.name + ' <em>products</em>';
        this.$refs.productSlider.linkText = 'View ' + this.option.name + ' products';
        this.$refs.productSlider.query = { producer: this.option.value };
        this.$refs.productSlider.loadFilteredProducts(filters);
      }
    },
    created: function () {
      this.load();
      this.loadPageContent();
    }
  };
</script>
